
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Renderer, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenVideo } from './openvideo';

@Component({
  selector: 'app-billboard',
  templateUrl: './billboard.component.html',
  styleUrls: ['./billboard.component.scss']
})
export class BillboardComponent extends OpenVideo implements OnInit {
  @Input() pageConfig: any;
  @Input() localStrings: Array<any>;
  @Input() hasFindDealerForm: boolean;

  @Output() onOpenModal = new EventEmitter;

  constructor(public dialog: MatDialog) {
    super(dialog);
  }

  ngOnInit() {
  }

  goToUrl(): void {
    window.location.href = this.pageConfig.ButtonLearnMoreCalloutLink;
  }

  openModal(modalName: string) {
    this.onOpenModal.emit(modalName);
  }
}

